/**
 * Safe lookups into the content pack's dictionaries (monsters, humans, items,
 * skills, passives, dungeons). Ids arrive in JSON (party members, commands),
 * so an id may be any value and a string id may name an inherited key such as
 * `constructor`. Every content lookup in game-core goes through `lookup`.
 */

/** The entry `id` of `dict`, or null unless `id` is a string naming an own key of `dict`. */
export const lookup = <T>(dict: Readonly<Record<string, T>>, id: unknown): T | null =>
  typeof id === 'string' && Object.hasOwn(dict, id) ? (dict[id] ?? null) : null;
